const permissions = {
    PUSH: "PUSH_ADMIN",
    ANNOUNCEMENT: "ANNOUNCEMENT_ADMIN"

}
Object.freeze(permissions);

export { permissions };